require('./mortgageRequestSimpleNoteUploaded.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const { takeRight, filter, isEmpty, each, map, find } = require('lodash')

// @ utilities
const { addOrdinal } = require('utilities/stringHelper');

// @ commons
const { formatText, getLanguage } = require('core/i18n').i18n;

// @ components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ constants
const { ESTATES_TYPE } = require('constants/mortgageRequestHolderData');
const DOCUMENTS_TYPES = require('constants/mortgageRequestDocumentsTypes');

// @ actions
const mortgageInmueblesActions = require('actions/mortgageRequest/mortgageRequestInmuebles');
const mortgageRequestEstatesActions = require('actions/mortgageRequest/mortgageRequestEstates');
const documentActions = require('actions/mortgageRequest/mortgageRequestDocumentationCenter');
const stateActions = require('actions/mortgageRequest/mortgageRequestState');

class MortgageRequestSimpleNoteUploaded extends React.Component {
    constructor(props) {
        super(props);

        this.estates = {
            livingPlace: [],
            storageRooms: [],
            garages: []
        };
        this.estatesDocuments = {};

        this.handleOnDownloadFile = this.handleOnDownloadFile.bind(this);
        this.handleOnReturnToPanel = this.handleOnReturnToPanel.bind(this);
    }

    componentWillMount() {
        const { requestEstates, requestSummaryDocumentation } = this.props;

        requestEstates();
        requestSummaryDocumentation();
    }

    buildEstateDetail(estate, idx) {
        const estateDoc = this.estatesDocuments[estate.bienId];
        const ordinal = estate.tipoBien !== ESTATES_TYPE.VIVIENDA ? addOrdinal(getLanguage(), idx + 1) : '';
        let estateTypeTitle;

        switch (estate.tipoBien) {
            case ESTATES_TYPE.VIVIENDA:
                estateTypeTitle = (
                    <strong className="mortgage-request-simple-note-uploaded__list-item-title">
                        {formatText('mortgageRequestSimpleNote-livingPlace')}
                    </strong>
                );
                break;
            case ESTATES_TYPE.TRASTERO:
                estateTypeTitle = (
                    <p className="mortgage-request-simple-note-uploaded__list-item-title">
                        {`${ordinal} ${formatText('mortgageRequestSimpleNote-storageRoom')}`}
                    </p>
                );
                break;
            case ESTATES_TYPE.GARAJE:
                estateTypeTitle = (
                    <p className="mortgage-request-simple-note-uploaded__list-item-title">
                        {`${ordinal} ${formatText('mortgageRequestSimpleNote-garage')}`}
                    </p>
                );
                break;
        }

        const includedEstatesHtml = estate.tipoBien === ESTATES_TYPE.VIVIENDA && this.buildIncludedEstates(estate);

        return (
            <div key={idx} className="row no-outside-gutter mortgage-request-simple-note-uploaded__list-item">
                <div className="col-md-5">
                    {estateTypeTitle}
                    {includedEstatesHtml}
                    {this.buildEstateDocumentLink(estate, estateDoc)}
                </div>
            </div>
        );
    }

    buildEstateDocumentLink(estate, estateDoc) {
        return (
            <a
                className="ok-link mortgage-request-simple-note-uploaded__list-item-link"
                onClick={(evt) => this.handleOnDownloadFile(evt, estate)}
            >
                {formatText('mortgageRequestSimpleNoteUploaded-docLink', [estateDoc.documentoId])}
            </a>
        );
    }

    buildIncludedEstates(estate) {
        let includesText = '';
        let storageRoomText = '';
        let garagesText = '';

        if (estate.storageRooms > 1) {
            storageRoomText = `${estate.storageRooms} ${formatText('mortgageRequestSimpleNote-storageRooms')}`;
        } else if (estate.storageRooms > 0) {
            storageRoomText = `${estate.storageRooms} ${formatText('mortgageRequestSimpleNote-storageRoom')}`;
        }

        if (estate.garages > 1) {
            garagesText = `${estate.garages} ${formatText('mortgageRequestSimpleNote-garages')}`;
        } else if (estate.garages > 0) {
            garagesText = `${estate.garages} ${formatText('mortgageRequestSimpleNote-garage')}`;
        }

        if (storageRoomText && garagesText) {
            includesText = formatText('mortgageRequestSimpleNote-includesAll', [storageRoomText, garagesText]);
        } else if (storageRoomText || garagesText) {
            includesText = formatText('mortgageRequestSimpleNote-includes', [storageRoomText || garagesText]);
        }

        return includesText && (
            <span className="mortgage-request-simple-note-uploaded__list-item-subtitle">
                {includesText}
            </span>
        );
    }

    handleOnDownloadFile(evt, estate) {
        evt.preventDefault();

        this.props.requestDocument({
            documentType: DOCUMENTS_TYPES.NS_CLI,
            documentEstateId: estate.bienId,
            NSType: estate.tipoBien
        });
    }

    handleOnReturnToPanel(evt) {
        evt.preventDefault();
        this.props.requestState('/myprofile/mortgage/panel', this.props.history)
    }

    loadData() {
        const { estatesState, summaryDocsState } = this.props;

        const estatesList = estatesState.get('list').toJS();

        this.estates = {
            livingPlace: takeRight(filter(estatesList, estate => estate.tipoBien === ESTATES_TYPE.VIVIENDA)),
            storageRooms: filter(estatesList, estate => estate.tipoBien === ESTATES_TYPE.TRASTERO),
            garages: filter(estatesList, estate => estate.tipoBien === ESTATES_TYPE.GARAJE)
        };

        each(this.estates, estateTypeList => {
            each(estateTypeList, estate => {
                const estateDoc = find(summaryDocsState.get('data').toJS(), file => {
                    return file.bienId === estate.bienId && file.tipoDocumentoId === DOCUMENTS_TYPES.NS_CLI;
                });

                this.estatesDocuments[estate.bienId] = estateDoc;
            });
        });
    }

    render() {
        const { estatesState, summaryDocsState } = this.props

        if (!estatesState.get('hasBeenFetched') || !summaryDocsState.get('documentsRequested')) {
            return <LoadingSection />;
        }

        this.loadData();

        const livingPlaceHtml = map(this.estates.livingPlace, (estate, idx) => this.buildEstateDetail(estate, idx));
        const storageRoomsHtml = map(this.estates.storageRooms, (estate, idx) => this.buildEstateDetail(estate, idx));
        const garagesHtml = map(this.estates.garages, (estate, idx) => this.buildEstateDetail(estate, idx));

        let otherEstatesTitle;
        if (!isEmpty(storageRoomsHtml) || !isEmpty(garagesHtml)) {
            otherEstatesTitle = <strong>{formatText('mortgageRequestSimpleNoteUploaded-otherEstates')}</strong>;
        }

        return (
            <div className="mortgage-request-simple-note-uploaded">
                <ContentBox>
                    <div className="row">
                        <div className="col-md-2">
                            <i className="mortgage-request-simple-note-uploaded__icon-success" />
                        </div>
                        <div className="col-md-10 mortgage-request-simple-note-uploaded__content">
                            <OKBoxTitle
                                value={formatText('mortgageRequestSimpleNoteUploaded-subtitle')}
                                size="medium"
                            />
                            <div className="row no-outside-gutter">
                                <div className="col-md-12 mortgage-request-simple-note-uploaded__list">
                                    {livingPlaceHtml}
                                    {otherEstatesTitle}
                                    {storageRoomsHtml}
                                    {garagesHtml}
                                </div>
                            </div>
                            <div className="row no-outside-gutter">
                                <div className="col-md-12 mortgage-request-simple-note-uploaded__text">
                                    <p>{formatText('mortgageRequestSimpleNoteUploaded-text')}</p>
                                </div>
                            </div>
                            <div className="row no-outside-gutter mortgage-request-simple-note-uploaded__footer">
                                <div className="col-md-5">
                                    <a href="#" className="ok-link" onClick={this.handleOnReturnToPanel}>
                                        {formatText('mortgageRequestSimpleNoteUploaded-returnToPanelLink')}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </ContentBox>
            </div>
        );
    }
}

MortgageRequestSimpleNoteUploaded.propTypes = {
    estatesState: PropTypes.object,
    summaryDocsState: PropTypes.object,
    docCenterState: PropTypes.object,
    requestEstates: PropTypes.func,
    requestSummaryDocumentation: PropTypes.func,
    requestDocument: PropTypes.func,
    requestSimpleNote: PropTypes.func,
    requestState: PropTypes.func,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = MortgageRequestSimpleNoteUploaded;

module.exports.MortgageRequestSimpleNoteUploaded = withRouter(connect(state => ({
    estatesState: state.mortgageRequestInmuebles,
    summaryDocsState: state.mortgageRequestSummaryDocumentation,
    docCenterState: state.mortgageRequestDocumentationCenter
}), {
    requestEstates: mortgageInmueblesActions.requestInmuebles,
    requestSummaryDocumentation: mortgageRequestEstatesActions.fetchSimpleNotes,
    requestDocument: documentActions.getDocument,
    requestState: stateActions.requestState
})(MortgageRequestSimpleNoteUploaded));
